import { isPlaceholderFwVer, fwVerCore } from "./mouseFirmwareVersion";

/** 从设备信息对象中提取固件版本（与子应用 useFirmwareData 字段优先级一致） */
export function pickKeyboardFirmwareVersionFromRecord(
  data: Record<string, unknown> | null | undefined
): string | null {
  if (!data) return null;
  const version =
    data.appVersion ?? data.firmwareVersion ?? data.version ?? null;
  if (version == null) return null;
  const text = String(version).trim();
  return text || null;
}

/** 智慧无限占位版本（info_tab 未写入时 SDK 可能返回 00.00） */
function isZhwxUnsetFirmwareVersionText(version: unknown): boolean {
  const core = fwVerCore(String(version ?? ""));
  return /^0+\.0+$/.test(core);
}

/**
 * 首页设备卡片：当前固件版本是否可信（可读且非占位）。
 * 不可信时不展示「有新固件」角标。
 */
export function isReliableKeyboardFirmwareVersion(
  version: unknown,
  provider?: string
): boolean {
  if (version == null) return false;
  const text = String(version).trim();
  if (!text) return false;
  if (isPlaceholderFwVer(text)) return false;
  const sol = String(provider ?? "").trim();
  if (sol === "ZHWX" && isZhwxUnsetFirmwareVersionText(text)) return false;
  return true;
}
